import PropTypes from "prop-types";
import React from "react";
import { Select } from "cxa-components";
import { FormField } from "cxa-form-field";
import { injectIntl } from "react-intl";

const IntlOption = injectIntl(({ item, valueKey, labelKey, intl }) =>
  <option key={item[valueKey]} value={item[valueKey]}>
    {intl.formatMessage({ id: item[labelKey], defaultMessage: item[labelKey] })}
  </option>
);

const IntlSelectField = ({
  items,
  valueKey = "value",
  labelKey = "label",
  ...props
}) =>
  <FormField component={Select} boxed {...props}>
    {items.map((item, index) =>
      <IntlOption
        key={`unit${index}`}
        item={item}
        valueKey={valueKey}
        labelKey={labelKey}
      />
    )}
  </FormField>;

IntlSelectField.propTypes = {
  items: PropTypes.array,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
};

export default IntlSelectField;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/display-types/intlSelectField.jsx